import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { ModalController, ToastController } from "@ionic/angular";
import { MatDialogRef } from "@angular/material/dialog";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MasterService } from "src/app/services/master.service";
import { CorrigendumRequestModel } from "src/app/model/CorrigendumRequestModel";
import { CorrigendumUploadModel } from "src/app/model/CorrigendumUploadModel";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-modal",
  templateUrl: "./modal.component.html",
  styleUrls: ["./modal.component.scss"],
})
export class ModalComponent implements OnInit {
  key: number;
  base64File: string;
  public uploadedDocument: string;
  public uploadedDocumentTimestamp: Date;
  public isFileUploaded: boolean = false;
  form: FormGroup = new FormGroup({});
  selectedFile: File;
  corrigendumName: string = "";
  isLoading = false;
  CorrigendumResponseModel: CorrigendumUploadModel;
  corrigendumFileNameSelect: string;
  pageMode: string;
  corrigendumBase64: string;
  FileNameList: any[] = [
    { name: "Corrigendum", value: "Corrigendum" },
    {
      name: "Caste Validity Verification",
      value: "Caste Validity Verification",
    },
    {
      name: "Important Announcement",
      value: "Important Announcement",
    },
    {
      name: "Important Correspondence",
      value: "Important Correspondence",
    },
    {
      name: "Other",
      value: "OTHER",
    },
  ];
  @Output() dataModal = new EventEmitter<string>();

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private masterService: MasterService,
    // public dialogRef: MatDialogRef<ModalComponent>,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    // console.log("this.key", this.key);

    if (this.key) {
      this.masterService
        .initCorrigendumDetails(this.key)
        .subscribe((data: any) => {
          if (data.status === "SUCCESS") {
            this.CorrigendumResponseModel = data;

            this.pageMode = "Edit";
            this.form.patchValue({
              // corrigendumFileName:
              //   this.CorrigendumResponseModel.corrigendumFileName,
              corrigendumName: this.CorrigendumResponseModel.corrigendumName,
            });
            this.corrigendumBase64 =
              this.CorrigendumResponseModel.corrigendumFileName;
          } else {
            this.pageMode = "Add";
          }
        });
    }
    this.form = new FormGroup({
      corrigendumName: new FormControl(null, [
        Validators.required,
        Validators.maxLength(255),
      ]),
      corrigendumSelect: new FormControl(null, [
        Validators.required,
        // Validators.maxLength(255),
      ]),
      // corrigendumFileName: new FormControl(null, [Validators.required]),
    });
  }

  cancel() {
    this.modalCtrl.dismiss(null, "cancel");
  }

  onSavePdf() {
    // const corrigendumName = this.form.value.corrigendumName;
    const corrigendumData = {
      key: this.key,
      // corrigendumName:
      //   this.form.value.corrigendumName === null ||
      //   this.form.value.corrigendumName === ""
      //     ? this.form.value.corrigendumSelect
      //     : this.form.value.corrigendumName,
      corrigendumName:
        this.form.value.corrigendumSelect === "OTHER"
          ? this.form.value.corrigendumName
          : this.form.value.corrigendumSelect,
      corrigendumFileName: this.corrigendumBase64,
    };
    // console.log("before save", this.corrigendumBase64);
    this.modalCtrl.dismiss(corrigendumData, "submit");
  }

  onCorrigendumFileNameChange(value: any) {
    this.corrigendumFileNameSelect = value;
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
    //remove if/else condition if we want to remove pdf condition
    if (this.selectedFile) {
      if (this.isFileTypeAllowed(this.selectedFile.type)) {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.corrigendumBase64 = reader.result as string;
          // console.log("base64String", this.corrigendumBase64);
        };

        reader.readAsDataURL(this.selectedFile);
      } else {
        this.errorToast("Please select a valid PDF file.");
        // console.log("Please select a valid PDF file.");
      }
    }
  }

  isFileTypeAllowed(fileType: string): boolean {
    // Define allowed file types
    const allowedTypes = [
      "application/pdf",
      "image/png",
      "image/jpeg",
      "image/jpg",
    ];

    // Check if the fileType is included in the allowedTypes array
    return allowedTypes.includes(fileType);
  }

  public handleFileInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const file = inputElement.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        const fileContent = event.target.result;
        this.form.patchValue({ corrigendumFileName: fileContent });
      };
      reader.readAsDataURL(file);
    }
  }

  downloadCorrigendum() {
    this.masterService.downloadCorrigendum(this?.key).subscribe(
      (res) => {
        this.isLoading = false;
        // console.log("base64base64", res.status);

        if (res.status === "SUCCESS") {
          const base64 = res;
          this.downloadFile(base64?.data, base64?.fileName);
        } else {
          this.errorToast(res.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  downloadFile(base64File: string, fileName: string) {
    const byteArray = new Uint8Array(
      atob(base64File)
        .split("")
        .map((char) => char.charCodeAt(0))
    );

    if (this.isPDF(byteArray)) {
      this.downloadPDF(byteArray, fileName);
    } else {
      // Assuming it's an image if not identified as a PDF
      this.downloadImage(base64File, fileName);
    }
    // const byteArray = new Uint8Array(
    //   atob(base64File)
    //     .split("")
    //     .map((char) => char.charCodeAt(0))
    // );

    // let blob = new Blob([byteArray], { type: "application/pdf" });
    // const url = URL.createObjectURL(blob);
    // const a = document.createElement("a");
    // a.href = url;
    // a.download = fileName;
    // a.click();
    // URL.revokeObjectURL(url);
    // a.remove();
  }

  isPDF(byteArray) {
    // Check if the file starts with "%PDF"
    return (
      byteArray.length > 4 &&
      byteArray[0] === 0x25 &&
      byteArray[1] === 0x50 &&
      byteArray[2] === 0x44 &&
      byteArray[3] === 0x46
    );
  }

  downloadPDF(byteArray, fileName) {
    const blob = new Blob([byteArray], { type: "application/pdf" });
    this.downloadBlob(blob, fileName);
  }

  downloadImage(base64File, fileName) {
    const byteArray = new Uint8Array(
      atob(base64File)
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    const blob = new Blob([byteArray], { type: "image/jpeg" });
    this.downloadBlob(blob, fileName);
  }

  downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  get corrigendumDetails() {
    return this.form.get("corrigendumLst")["controls"];
  }
}
